module.exports = __webpack_public_path__ + "static/media/SchoolCosHero.8421b395.png";